export const ANNOTATION_SUB_TYPE_VALUE = {
  RESEARCH_KEYWORDS: 'research-keywords',
  GENERATING_INSIGHTS: 'generating-insights',
  READY_TO_IMPROVE_CONTENT: 'ready-to-improve-content',
  IN_PROGRESS: 'in-progress',
  CHANGES_ABANDONED: 'changes-abandoned',
  PUBLISHED_LIVE: 'published',
  DRAFT: 'draft',
};

export const CR_CHANGE_STATUS = [
  { text: 'Research Keywords', value: ANNOTATION_SUB_TYPE_VALUE.RESEARCH_KEYWORDS, color: '#A3A3A3' },
  { text: 'Generating Insights', value: ANNOTATION_SUB_TYPE_VALUE.GENERATING_INSIGHTS, color: '#27AE60' },
  { text: 'Ready to Improve Content', value: ANNOTATION_SUB_TYPE_VALUE.READY_TO_IMPROVE_CONTENT, color: '#27AE60' },
  { text: 'In Progress', value: ANNOTATION_SUB_TYPE_VALUE.IN_PROGRESS, color: '#F0882D' },
  {
    text: 'Published Changes',
    value: ANNOTATION_SUB_TYPE_VALUE.PUBLISHED_LIVE,
    color: '#27AE60',
    idDisplayForChangeStatus: true,
  },
  {
    text: 'Abandoned Changes',
    value: ANNOTATION_SUB_TYPE_VALUE.CHANGES_ABANDONED,
    color: 'red',
    idDisplayForChangeStatus: true,
  },
  { text: 'Draft', value: 'draft', color: '#A3A3A3', hideForOrg: true },
];

export const RESOLVE_RECOMMENDATION_OPTIONS = [
  { text: 'New', value: 'new', color: '#A3A3A3' },
  { text: 'Fix Deployed', value: 'fix-deployed', color: '#27AE60' },
  { text: 'Not Feasible', value: 'not-feasible', color: 'red' },
  { text: 'Not an Issue', value: 'not-an-issue', color: '#27AE60' },
  { text: 'In Progress', value: 'in-progress', color: '#F0882D' },
];

export const RECOMMENDATION_STATUS_OPTIONS = [
  { text: 'No Change', value: 'NO_CHANGE' },
  { text: 'New', value: 'NEW' },
  { text: 'Resolved', value: 'RESOLVED' },
  { text: 'Improved', value: 'IMPROVED' },
  { text: 'Fix Detected', value: 'FIX_DETECTED' },
  { text: 'Worse', value: 'WORSE' },
];

export const KEYWORD_LIST_SKIP_COLUMNS = [
  'Relevance Score',
  'Average Organic Position',
  'CPC',
  'CPA',
  'CTR',
  'Keywords',
];

export const CNP_RESOLVE_RECOMMENDATION_OPTIONS = [
  { text: 'Draft', value: 'draft', color: '#A3A3A3' },
  { text: 'Published', value: 'published', color: '#27AE60' },
];

export const ANNOTATION_TYPE = {
  PUBLISHED: 'published',
  RESOLUTION: 'resolution',
};
